import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import leftarrow from '../../../safreeimg/left-arrow.png'


const OrgUserAlarms = () => {
    const [alarms, setAlarms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [showForm, setShowForm] = useState(false);
    const [selectedAlarm, setSelectedAlarm] = useState(null);

    const rowsPerPage = 10;
    const navigate = useNavigate(); 
    const fetchAlarms = async () => {
        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('token');
            if (!token) {
                setError('No token found');
                setLoading(false);
                return;
            }

            // Extract ID from URL hash
            const hashId = window.location.hash.replace('#', '');
            if (!hashId) {
                setError('No ID found in URL');
                setLoading(false);
                return;
            }

            const response = await axios.get(`https://api.safree.org/api-v2022/organization/auth/v1/orgAlarms-users/${hashId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setAlarms(response.data.data.alarms);
        } catch (err) {
            setError('Error fetching data: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAlarms();
    }, []);

    const totalPages = Math.ceil(alarms.length / rowsPerPage);
    const currentRows = alarms.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) setCurrentPage(currentPage - 1);
        if (direction === 'next' && currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleView = (alarm) => {
        setSelectedAlarm(alarm);
        setShowForm(true);
    };

    const closeForm = () => setShowForm(false);

    if (loading) return <div className='loading'><img src={Loader} alt='Loading...' /></div>;
    if (error) return <div>Error: {error}</div>;
    const handleBackClick = () => {
        navigate(-1);  
      };

      const getPageNumbers = () => {
        const maxPageNumbersToShow = 5; 
        const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
        const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);
    
        const pageNumbers = [];
        for (let i = startPage; i <= endPage; i++) {
          pageNumbers.push(i);
        }
        return pageNumbers;
      };
    return (
        <div className='container user-management'>
            <div className='row header'>
                <div className='col-md-6'>
                    <p className='sub-heading'> <img  onClick={handleBackClick} className="back-button" src={leftarrow} alt="" />User Alarms Management</p>
                </div>
            </div>

            <div className='content-wrapper'>
                <div className='table-container tbcon'>
                    <table className='styled-table'>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Date</th>
                                <th>Reason</th>
                                <th>Audios</th>
                                <th>Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((alarm, index) => (
                                <tr key={alarm.alarmId}>
                                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                    <td>{alarm.name}</td>
                                    <td>{alarm.userEmail}</td>
                                    <td>{alarm.userPhoneNumber}</td>
                                    <td>{new Date(alarm.created).toLocaleDateString()}</td>
                                    <td>{alarm.reasonTitle}</td>
                                    <td>
                                        {alarm.chunkFiles?.length ? (
                                            <audio controls>
                                                <source src={alarm.chunkFiles[0]} type='audio/aac' />
                                                Your browser does not support the audio element.
                                            </audio>
                                        ) : 'No Audio Available'}
                                    </td>
                                    <td>
                                        <button className='btn btn-view' onClick={() => handleView(alarm)}>View</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="pagination-container">
              <button
                className="pagination-btn"
                onClick={() => handlePageChange('prev')}
                disabled={currentPage === 1}
              >
                &laquo; Prev
              </button>
              {getPageNumbers().map((page) => (
                <button
                  key={page}
                  className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}
              <button
                className="pagination-btn"
                onClick={() => handlePageChange('next')}
                disabled={currentPage === totalPages}
              >
                Next &raquo;
              </button>
            </div>
                </div>
            </div>

            <div className={`side-form ${showForm ? 'show' : ''}`}>
                <h3>Location</h3>
                {selectedAlarm && selectedAlarm.location && (
                    <MapContainer
                        center={[selectedAlarm.location.latitude, selectedAlarm.location.longitude]}
                        zoom={13}
                        style={{ height: '300px', width: '100%' }}
                    >
                        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
                        <Marker
                            position={[selectedAlarm.location.latitude, selectedAlarm.location.longitude]}
                            icon={new L.Icon({
                                iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
                                iconSize: [25, 41],
                                iconAnchor: [12, 41]
                            })}
                        >
                            <Popup>
                                <strong>Location:</strong> {selectedAlarm.location.raw}
                            </Popup>
                        </Marker>
                    </MapContainer>
                )}

                {selectedAlarm && selectedAlarm.location ? (
                    <>
                        <p><strong>Location:</strong> {selectedAlarm.address || 'N/A'}</p>
                        <p><strong>Latitude:</strong> {selectedAlarm.location.latitude || 'N/A'}</p>
                        <p><strong>Longitude:</strong> {selectedAlarm.location.longitude || 'N/A'}</p>
                    </>
                ) : (
                    <p>Location data not available</p>
                )}

                <button className='btn-cancel' onClick={closeForm}>Close</button>
            </div>

        </div>
    );
};

export default OrgUserAlarms;
